import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export interface IGenerateCustomerAccountOnboardingLinkRequest {
  companyID: string;
  customerAccountID: string;
  profileInfo?: boolean;
  bankInfo?: boolean;
  sendToCustomer?: boolean;
}

export interface IGenerateCustomerAccountOnboardingLinkResponse {
  link: string;
}

export const generateCustomerAccountOnboardingLink = (
  axios: IAxiosInstance
) => {
  return async (data: IGenerateCustomerAccountOnboardingLinkRequest) => {
    const response = await axios.noRetry.post<IApiResponse<{ link: string }>>(
      "/customer-accounts/onboard",
      data
    );

    if (!response?.data?.success) {
      throw new Error("Something went wrong");
    }

    return response?.data?.data;
  };
};
